import React from 'react';
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion, SFEntityID } from 'utils/types';
import css from './DesktopCommentsRow.css';
import { Table } from 'semantic-ui-react';
import Comment from './Comment';

export default class DesktopCommentsRow extends React.Component {

  get class() {
    return `${css['row']} ${this.props.hasError ? css['error'] : ""} `;
  }

  render() {
    return (
      <Table.Row className={this.class}>
        <Table.Cell />
        <Table.Cell colSpan={this.props.numberOfQuestions} className={css['comments-container']}>
          {this.props.checkedQuestions.map((question) => (
            <Comment 
              key={question.id} 
              studentId={this.props.studentId}
              studentName={this.props.studentName}
              onAnswerChanged={this.props.onAnswerChanged}
              answers={this.props.answers} 
              question={question} 
              isMobile={false}
            />
          ))}
        </Table.Cell>
      </Table.Row>
    );
  }
}

DesktopCommentsRow.propTypes = {
  studentId: SFEntityID.isRequired,
  studentName: PropTypes.string.isRequired,
  numberOfQuestions: PropTypes.number.isRequired,
  checkedQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  onAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.array,
  hasError: PropTypes.bool.isRequired
};
